import { render } from "./PieChartComponent.vue?vue&type=template&id=1b60f47f"
import script from "./PieChartComponent.vue?vue&type=script&lang=js"
export * from "./PieChartComponent.vue?vue&type=script&lang=js"

import "./PieChartComponent.vue?vue&type=style&index=0&id=1b60f47f&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__